export default __webpack_public_path__ + "alberta-play.bb88aeb1bf042ab9900d.svg";